import { Box } from '@mui/material';
import React from 'react';

/**
 * SyncStatusBadge — small "Unsynced" indicator shown when the local clone
 * has uncommitted changes. Used in project detail toolbar and project cards.
 *
 * Hidden in standalone mode (no concept of "synced" without a remote).
 */
const SyncStatusBadge = ({ syncStatus, isDirty }) => {
  // Accept either a syncStatus object or a direct isDirty boolean
  const dirty = isDirty ?? syncStatus?.dirty;
  if (!dirty) return null;

  return (
    <Box
      sx={{
        bgcolor: '#EA4C7A',
        color: '#fff',
        fontSize: 10,
        fontWeight: 600,
        px: 1,
        py: 0.25,
        borderRadius: 1,
        lineHeight: 1.4,
      }}
    >
      Unsynced
    </Box>
  );
};

export default SyncStatusBadge;
